import { Dynamo } from '.';

export type AppPermissions = {
    idsAndInfo: ViewEditPermissions;
    medications: ViewEditPermissions;
    conditions: ViewEditPermissions;
    allergies: ViewEditPermissions;
    careTeam: ViewEditPermissions;
    visits: ViewEditPermissions;
    patientPortals: ViewEditPermissions;
    cloudCalendars: ViewEditPermissions;
    settings: ViewEditPermissions;
    reports: ViewEditPermissions;
    files: ViewEditPermissions;
    procedures: ViewEditPermissions;
    vaccinations: ViewEditPermissions;
    imaging: ViewEditPermissions;
    labs: ViewEditPermissions;
    collaborators: ViewEditPermissions;
};

export type ABACRuleSetEntity = {
    entityId: string;
    entityType: Dynamo.ABACRuleSetEntityType;
};

export type RuleType =
    | 'global'
    | 'ids-and-info'
    | 'medications'
    | 'conditions'
    | 'allergies'
    | 'care-team'
    | 'visits'
    | 'patient-portals'
    | 'cloud-calendars'
    | 'collaborators'
    | 'settings'
    | 'collaborator-invites'
    | 'reports'
    | 'files'
    | 'procedures'
    | 'imaging'
    | 'vaccinations'
    | 'labs';

export type ViewEditPermissions = 'view' | 'edit' | 'denied';

export type GlobalConfig = {
    ruleType: 'global';
    permission: ViewEditPermissions;
};

export type IdsAndInfoConfig = {
    ruleType: 'ids-and-info';
    permission: ViewEditPermissions;
};

export type MedicationsConfig = {
    ruleType: 'medications';
    permission: ViewEditPermissions;
};

export type ConditionsConfig = {
    ruleType: 'conditions';
    permission: ViewEditPermissions;
};

export type AllergiesConfig = {
    ruleType: 'allergies';
    permission: ViewEditPermissions;
};

export type ProceduresConfig = {
    ruleType: 'procedures';
    permission: ViewEditPermissions;
};

export type ImagingConfig = {
    ruleType: 'imaging';
    permission: ViewEditPermissions;
};

export type VaccinationsConfig = {
    ruleType: 'vaccinations';
    permission: ViewEditPermissions;
};

export type CareTeamConfig = {
    ruleType: 'care-team';
    permission: ViewEditPermissions;
};

export type VisitsConfig = {
    ruleType: 'visits';
    permission: ViewEditPermissions;
};

export type PatientPortalsConfig = {
    ruleType: 'patient-portals';
    permission: ViewEditPermissions;
};

export type CloudCalendarsConfig = {
    ruleType: 'cloud-calendars';
    permission: ViewEditPermissions;
};

export type CollaboratorsConfig = {
    ruleType: 'collaborators';
    permission: ViewEditPermissions;
};

export type SettingsConfig = {
    ruleType: 'settings';
    permission: ViewEditPermissions;
};

export type CollaboratorInvitesConfig = {
    ruleType: 'collaborator-invites';
    permission: ViewEditPermissions;
};

export type ReportsConfig = {
    ruleType: 'reports';
    permission: ViewEditPermissions;
};

export type FilesConfig = {
    ruleType: 'files';
    permission: ViewEditPermissions;
};

export type LabsConfig = {
    ruleType: 'labs';
    permission: ViewEditPermissions;
};

export type RuleConfig =
    | GlobalConfig
    | IdsAndInfoConfig
    | MedicationsConfig
    | ConditionsConfig
    | AllergiesConfig
    | VisitsConfig
    | CareTeamConfig
    | PatientPortalsConfig
    | CloudCalendarsConfig
    | CollaboratorsConfig
    | SettingsConfig
    | CollaboratorInvitesConfig
    | ReportsConfig
    | FilesConfig
    | ProceduresConfig
    | ImagingConfig
    | VaccinationsConfig
    | LabsConfig;

export type RuleSet = RuleConfig[];

export type ABACSubject =
    | 'all'
    | 'ids-and-info'
    | 'medications'
    | 'conditions'
    | 'allergies'
    | 'care-team'
    | 'visits'
    | 'notes'
    | 'patient-portals'
    | 'cloud-calendars'
    | 'settings'
    | 'reports'
    | 'files'
    | 'procedures'
    | 'imaging'
    | 'vaccinations'
    | 'labs'
    | 'collaborators';

export type ABACAction = 'edit' | 'view';

export type EnforceCollaboratorMedicalProfileAccessOptions = {
    enforceCollaborator: true;
};

export type EnforcePolicyMedicalProfileAccessOptions = {
    action: ABACAction;
    subjects: ABACSubject[];
};

export type MedicalProfileEnforcementArgs =
    | EnforceCollaboratorMedicalProfileAccessOptions
    | EnforcePolicyMedicalProfileAccessOptions;
export type MedicalProfileEnforcementContext = {
    isProfileOwner: boolean;
    isCollaborator: boolean;
    ruleSet: RuleSet | null;
    collaboratorId: string | null;
};

export type EnforceMedicalProfileAccessArgs = {
    enforcementArgs: MedicalProfileEnforcementArgs;
    enforcementContext: MedicalProfileEnforcementContext;
};
